import { CropConfig } from '../utils/imageCropUtils';
import { useCroppedImage } from './useCroppedImage';

const useImage = ({
  isAuthenticated,
  isDiscoverTemplate,
  cropConfig,
  fileId,
  type,
  isOwner,
}: {
  type?: string | null;
  fileId?: string | null;
  cropConfig?: CropConfig | null;
  isDiscoverTemplate: boolean;
  isAuthenticated: boolean;
  isOwner: boolean; //TODO: make this check for places where the isOwner should be set to true like in the designer, currently only using public endpoints
}) => {
  const { imageUrl, isLoading, isSuccess } = useCroppedImage({
    fileId: fileId,
    cropConfig: cropConfig,
    fileMimetype: type,
    isDiscoverTemplate: isDiscoverTemplate,
    isAuthenticated,
    isOwner,
  });

  if (imageUrl) {
    return { url: imageUrl };
  }
  if (type === 'image/unsplash') {
    return { url: fileId };
  }
  if (type === 'image/color') {
    return { url: fileId };
  }

  return { url: undefined, isLoading: !isSuccess && !imageUrl && isLoading };
};
export default useImage;
